// MAIN SCRIPT
jQuery(document).ready(function ($) {
  const BUCKAROO = window['BUCKAROO'] || {};

  BUCKAROO.initFeaturedProductsCarousel = function () {
    $('.featured-products__carousel').slick({
      dots: false,
      infinite: false,
      slidesToShow: 4.2,
      prevArrow: $('.carousel__controls--left'),
      nextArrow: $('.carousel__controls--right'),
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4.2,
          },
        },
        {
          breakpoint: 1599,
          settings: {
            slidesToShow: 3.2,
          },
        },
        {
          breakpoint: 924,
          settings: {
            slidesToShow: 2.2,
            arrows: false,
            dots: true,
          },
        },
        {
          breakpoint: 620,
          settings: {
            slidesToShow: 1.2,
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  };

  BUCKAROO.init = function () {
    BUCKAROO.toggleGetHelpForm();
  };

  BUCKAROO.toggleGetHelpForm = function () {
    const $pageForm = $('.template-suffix-get-help-upflowy .page-section-spacing');
    const $pageToggle = $('.template-suffix-get-help-upflowy .toggle-form-display');
    $pageForm.css({ display: 'none' });
    $pageToggle.on('click', function (e) {
      e.preventDefault();
      if ($pageToggle.hasClass('show')) {
        $pageToggle.removeClass('show');
        $pageForm.fadeOut();
      } else {
        $pageToggle.addClass('show');
        $pageForm.fadeIn();
        $('html,body').animate({ scrollTop: $pageForm.offset().top }, 500);
      }
    });
  };

  BUCKAROO.initTabMenu = function () {
    const $tabMenu = $('.nav-tabs .nav-link:not(.non-ajax)');
    if ($tabMenu.length > 0) {
      $tabMenu.on('click', function (e) {
        e.preventDefault();
        let $this = $(this);
        if ($this.data('target') == '') {
          window.location.href = $this.attr('href');
        }
        if ($this.hasClass('toggle') && $this.hasClass('active')) {
          $this.parent().parent().parent().find('.nav-link').removeClass('active');
          $('.tab-pane.fade').fadeOut('fast'); //css({"visibility":"hidden", "height":"0"});
          $('.tab-pane.slide').slideUp('fast');
        } else {
          const $nav_link = $this.parent().parent().parent().find('.nav-link');
          $nav_link.removeClass('active');
          $this.addClass('active');
          if ($nav_link.parent().parent().hasClass('owl-item')) {
            $('.tab-pane').css({ visibility: 'hidden', height: '0' });
            $($this.data('target')).css({ visibility: 'visible', height: 'auto' });
          } else {
            $('.tab-pane').css('display', 'none');
            $($this.data('target')).fadeIn();
          }
        }
      });
    }
    /* cancelled as per George june 2 2023 but returned oct 31 2023 */
    const $tabProductInfo = $('.product-detail-tab');
    if ($tabProductInfo.length > 0) {
      window.setTimeout(function () {
        $tabProductInfo.find('.nav-item:first-child .nav-link').trigger('click');
      }, 1000);
    }
  };

  BUCKAROO.initCarousel = function (container, callback) {
    var $owl = container;
    $owl.addClass('owl-carousel');
    $owl.each(function (i) {
      var owlScreenItems = 2;
      var owlShowDots = false;
      var owlShowNav = false;
      if ($(this).data('carousel-dots')) {
        owlShowDots = $(this).data('carousel-dots');
      }
      if ($(this).data('carousel-nav')) {
        owlShowNav = $(this).data('carousel-nav');
      }
      if ($(this).data('carousel-items')) {
        owlScreenItems = parseInt($(this).data('carousel-items'));
      }
      var owlOptions = {
        autoWidth: true,
        items: 3,
        nav: false,
        loop: false,
        dots: owlShowDots,
        onInitialized: BUCKAROO.removeMargin,
        responsive: {
          768: {
            nav: owlShowNav,
            items: owlScreenItems,
          },
        },
      };
      var owlActive = $(this).owlCarousel(owlOptions);
      owlActive.on('initialized.owl.carousel', function (event) {
        callback();
      });
    });
  };
  BUCKAROO.removeMargin = function (e) {
    if ($(window).width() < 768) {
      if ($(e.currentTarget).hasClass('product-list')) {
        $(e.currentTarget).css('margin', '0');
      }
    }
  };
  // No code should be added below this
  window['BUCKAROO'] = BUCKAROO;
  BUCKAROO.init();
});

(function ($) {
  var $ = (jQuery = $);
  $(function ($) {
    let currentBeltSelection = 'L';
    let currentBeltSize = 0;
    let cookieAttachments = {};
    const $accordion = $('.accordion');
    const sectionJson = JSON.parse(attachmentSectionText);
    const attachmentWidthJson = JSON.parse(attachmentWidthText);

    $accordion.find('.caret').on('click', function (e) {
      e.preventDefault();
      if ($(this).parent().parent().hasClass('accordion--open')) {
        $(this).parent().parent().removeClass('accordion--open');
      } else {
        $(this).parent().parent().addClass('accordion--open');
      }
    });
    var resetBYOBCookies = function () {
      Cookies.remove('byob_belt');
      Cookies.remove('byob_attachments');
    };
    var getAttachmentData = function () {
      var byob_attachments = Cookies.get('byob_attachments');
      if (byob_attachments == undefined) {
        byob_attachments = '{}';
      }
      return JSON.parse(byob_attachments);
    };
    var getAjaxData = function (url, target, callback = 0, modQuickBuy = 0) {
      $.ajax({
        url: url,
        type: 'GET',
      })
        .done(function (data) {
          if (modQuickBuy) {
            var delay = setTimeout(function () {
              BUCKAROO.initTabMenu();
            }, 2000);
            var $newDetail = $('<div>' + data + '</div>').find('.quickbuy-content');
            // convert to quickbuy content
            $newDetail.find('.more').attr('href', url);
            $newDetail.find('.detail .title').wrapInner($('<a>').attr('href', url));
            $newDetail.find('.show-gallery').removeClass('show-gallery').attr('href', url);
            $newDetail.find('.not-in-quickbuy').remove();
            $newDetail.find('.quantity-submit-row').remove();
            $newDetail.find('.only-in-quickbuy').removeClass('only-in-quickbuy');
            $newDetail.find('.sticky-content-container').removeClass('sticky-content-container');
            $newDetail.find('.store-availability-container').remove();
            $newDetail.find('[data-enable-history-state="true"]').attr('data-enable-history-state', 'false');
            $newDetail.find('.gallery .thumbnails').removeClass('mobile-only');
            [
              'gallery--layout-carousel-beside',
              'gallery--layout-columns-1',
              'gallery--layout-columns-2',
              'gallery--layout-collage-1',
              'gallery--layout-collage-2',
            ].forEach((cl) => {
              $newDetail
                .find('.' + cl)
                .removeClass(cl)
                .addClass('gallery--layout-carousel-under');
            });

            $(target).html($newDetail);
            $(target).parent().show();

            theme.initProductGallery($(target));
            $(target).find('.product-form').trigger('load-product-form'); // 2
            //loadComponents($quickbuyCont); // 3
            theme.initAnimateOnScroll(); // 4

            scrollNextBYOBField('', target);
          } else {
            $(target).html(data);
          }
          if (callback) {
            callback(callback);
          }
        })
        .fail(function (data) {})
        .always(function (data) {});
    };
    $('#footer__newsletter__fullname').on('keyup', function (e) {
      let fullname = $(this).val();
      fullname = fullname.split(' ');
      $('#footer__newsletter__firstname').val(fullname[0]);
      if (fullname[1].length > 1) {
        $('#footer__newsletter__lastname').val(fullname[1]);
      }
    });

    $.when($.ready).then(function () {
      const myTimeout = setTimeout(hideTabs, 3000);
      function hideTabs() {
        $('.section-buckaroo-collections .nav-tabs').each(function (i) {
          $(this).find('.nav-item .nav-link.active').trigger('click');
          //console.log("entriggerity");
        });
      }
      /*const myTimeout = setTimeout(hideTabs, 5000);
      function hideTabs() {
        $(".collection-listing-wrapper.tab-pane")
          .css({"display":"none"})
          .first()
          .css({"display":"block"});
      }*/
      //applyPOSParam("body");
    });

    var initHashScroll = function () {
      var $scrollLink = $('.scroll-to');
      $scrollLink.on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        const a = $($this.attr('href'));
        $('html,body').animate(
          {
            scrollTop: $(a).offset().top,
          },
          'slow'
        );
      });
    };

    var scrollToTop = function () {
      $('html,body').animate(
        {
          scrollTop: $('.skip-link').offset().top,
        },
        'slow'
      );
    };

    var scrollFromRight = function () {
      if ($('.scroll-to-left--desktop').length > 0) {
        $('.scroll-to-left--desktop').scrollLeft($(this).width());
        $(window).scroll(function () {
          var elementTop = $('.scroll-to-left--desktop').offset().top,
            outerHeight = $('.scroll-to-left--desktop').outerHeight(),
            windowHeight = $(window).height(),
            elementScroll = $(this).scrollTop();
          if (
            elementScroll > elementTop + outerHeight - windowHeight &&
            elementTop > elementScroll &&
            elementScroll + windowHeight > elementTop + outerHeight
          ) {
            $('.scroll-to-left--desktop').animate(
              {
                scrollLeft: 0,
              },
              'slow',
              function () {
                $(this).find('.rimage__image').addClass('grayout');
              }
            );
          }
        });
      }
    };

    var scrollNextGuideMeField = function ($this) {
      var $container = $this;
      var target = $container.parent().parent().data('scroll');
      if ($container.hasClass('product-question__slider__item')) {
        target = $this.parent().parent().parent().parent().data('scroll');
      }
      if (target != null) {
        $('html,body').animate(
          {
            scrollTop: $(target).offset().top - 100,
          },
          'slow'
        );
      }
    };

    var scrollNextBYOBField = function ($this, target = '') {
      var $container = $this;
      if (target == '') {
        target = $container.parent().parent().data('scroll');
        if ($container.hasClass('product-block')) {
          target = $this.parent().parent().parent().parent().parent().data('scroll');
        }
      }
      if (target != null) {
        $('html,body').animate(
          {
            scrollTop: $(target).offset().top - 100,
          },
          'slow'
        );
      }
    };

    var initResponsiveFunc = function () {
      if ($(window).width() > 768) {
        scrollFromRight();
      }

      $(window).resize(function () {
        if ($(window).width() > 768) {
          scrollFromRight();
        }
      });
    };

    var getBeltSize = function (i) {
      var $beltBoundary = $('.belt_large_size_start');
      return i < $beltBoundary.val() ? 'regular' : 'large';
    };

    var resetBeltNavigation = function () {
      $('.product-picker .navbar-nav .nav-item a').first().trigger('click');
    };

    var showAttachmentFirstLevel = function () {
      $('.attachment-picker .nav-tabs .nav-item .nav-link').on('click', function () {
        var target = $(this).data('target');
        $(target).find('.navbar-nav .nav-item a').first().trigger('click');
      });
      $('.attachment-picker .nav-tabs .nav-item').first().find('.nav-link').trigger('click');
    };

    var hasAttachmentData = function (form = 'core') {
      let sections = new Array();
      var cookieBelt = JSON.parse(Cookies.get('byob_belt'));
      var cookieAttachments = getAttachmentData();
      // prepare empty obj
      if (form == 'core') {
        $.each(attachmentWidthJson[currentBeltSize], function (key, value) {
          sections.push(key);
        });
      } else {
        sections = ['D', 'N', 'B'];
      }
      $.each(sections, function (key, value) {
        var newObj = cookieAttachments[value];
        if (newObj != undefined && newObj.length > 0) {
          $('.attachment-link .btn--tertiary').addClass('started');
          $('.attachment-link .btn--tertiary[data-attachment-section=' + value + ']').addClass('filled');
          $('.belt-section-tracker').removeClass('hidden');
          $('#btn-byob-view-selections').text($('#btn-byob-view-selections').data('replace-text'));
        } else {
          $('.attachment-link .btn--tertiary[data-attachment-section=' + value + ']').removeClass('filled');
          updateSectionWidth(value, cookieBelt.size);
        }
      });
    };

    var showBaseBeltSize = function () {
      var cookieBelt = JSON.parse(Cookies.get('byob_belt'));
      var className = 'attachment-link--' + getBeltSize(cookieBelt.size);
      var className2 = 'belt-section-tracker--' + getBeltSize(cookieBelt.size);
      $('.attachment-link').removeClass('attachment-link--regular').removeClass('attachment-link--large');
      $('.attachment-link').addClass(className);

      $('.belt-section-tracker')
        .removeClass('belt-section-tracker--regular')
        .removeClass('belt-section-tracker--large');
      $('.belt-section-tracker').addClass(className2);
      hasAttachmentData();
      scrollToTop();
    };
    var getSectionData = function (key, field) {
      return sectionJson[key][field];
    };
    var getAttachmentWidthData = function (key, section) {
      return attachmentWidthJson[key][section];
    };
    var fillSectionMarkers = function (section) {
      var $replace = $('.replace-curly.section-name');
      var name = getSectionData(section, 'name');
      var id = getSectionData(section, 'id');
      $replace.each(function (i) {
        let text = $(this).data('text');
        text = text.replace('{section}', name.toUpperCase());
        $(this).text(text);
      });
      $('.indicator')
        .find('.pin--tertiary')
        .removeClass('active')
        .on('click', function (e) {
          e.preventDefault();
        });
      $('.indicator')
        .find('.pin--tertiary--' + id)
        .addClass('active');
    };
    var getSectionCode = function (section) {
      var search = 'left';
      switch (section) {
        case 'R':
          search = 'right';
          break;
        case 'MR':
          search = 'middle-right';
          break;
        case 'M':
          search = 'middle';
          break;
        case 'ML':
          search = 'middle-left';
          break;
      }
      return search;
    };
    var getAttachmentWidthLeft = function (size, section) {
      var cookieAttachments = getAttachmentData();
      var attachments = cookieAttachments[section];
      var sumAttachments = 0;
      var sectionWidth = getAttachmentWidthData(size, section);
      if (attachments != undefined && attachments.length > 0) {
        attachments.forEach(function (attachment, i) {
          sumAttachments = attachment.dimension + sumAttachments;
        });
      }
      return sectionWidth - sumAttachments;
    };
    var updateSectionWidth = function (section, size) {
      var remaining = getAttachmentWidthLeft(size, section);
      var available = getAttachmentWidthData(size, section);

      if (available == undefined) return false;
      var $replace = $('[data-section="' + section + '"] .replace-curly.section-available');
      var $bar = $('[data-section="' + section + '"] .byob-counter__progress span');
      var percentage = 100;
      if (remaining > 0) {
        percentage = 100 - (remaining / available) * 100;
      }

      $replace.each(function (i) {
        if (remaining == NaN) {
          remaining = 0;
        }
        $(this).text(remaining);
      });
      $bar.each(function (i) {
        $(this).css({ width: percentage + '%' });
      });
    };
    var prepareBeltSection = function (section) {
      var cookieBelt = JSON.parse(Cookies.get('byob_belt'));
      var className = 'attachment-link--' + getBeltSize(cookieBelt.size);
      currentBeltSelection = section;
      currentBeltSize = cookieBelt.size;
      fillSectionMarkers(currentBeltSelection);
      $('.attachment-link').removeClass('attachment-link--regular').removeClass('attachment-link--large');
      $('.attachment-link').addClass(className);

      $('#attachment-picker .byob-counter').attr('data-section', currentBeltSelection);
      var sectionCode = getSectionCode(currentBeltSelection);
      $('#attachment-picker .section-available').attr('data-text', '{available-' + sectionCode + '}');
      $('#attachment-picker .section-available').text('');
      updateSectionWidth(currentBeltSelection, currentBeltSize);
    };

    var triggerLoadProductForm = function () {
      $('.product-options .product-form').trigger('load-product-form');
      showBeltSample();
    };

    var showBeltSample = function () {
      var $beltSizeOption = $('[data-name=Size] .opt-btn');
      var $beltColorOption = $('[data-name=Colour] .opt-btn');
      var $beltThumb = $('.product-demo__image');
      var $beltRegularThumb = $('.product-demo__image--regular');
      var $beltLargeThumb = $('.product-demo__image--large');
      var $beltBoundary = $('.belt_large_size_start');
      var beltData,
        beltSize = 30;
      var varID = $('#product-picker .original-selector option:selected').val();
      var productID = $('#product-picker .product-block.active').data('product-id');
      var productHandle = $('#product-picker .product-block.active').data('product-handle');
      var beltColor,
        temp = '';
      temp = $('[data-name=Color] .opt-btn:checked').val();
      if (temp != undefined) {
        beltColor = temp;
      }

      //update variation id of belt, send it to cookie
      beltData = JSON.stringify({
        variation_id: varID,
        size: beltSize,
        product_id: productID,
        color: beltColor,
        handle: productHandle,
      });
      Cookies.remove('byob_belt');
      Cookies.set('byob_belt', beltData);

      $beltSizeOption.on('change', function () {
        var $this = $(this);
        if ($this.is(':checked')) {
          $beltThumb.fadeOut();
          beltSize = parseInt($this.val());
          if (beltSize < parseInt($beltBoundary.val())) {
            $beltRegularThumb.fadeIn();
          } else {
            $beltLargeThumb.fadeIn();
          }
          scrollNextBYOBField($this, '.option-selectors .option-selector[data-name=Colour]');
        }
      });

      $beltColorOption.on('change', function () {
        var $this = $(this);
        if ($this.is(':checked')) {
          beltColor = $this.val();

          scrollNextBYOBField($this, '#product-picker .product-demo');
        }
      });

      $('#product-picker .original-selector').on('change', function () {
        beltData = JSON.stringify({
          variation_id: $(this).val(),
          size: beltSize,
          product_id: productID,
          color: beltColor,
          handle: productHandle,
        });
        Cookies.remove('byob_belt');
        Cookies.set('byob_belt', beltData);
      });
    };

    var refreshBeltGrid = function () {
      var target = '.product-picker .products';
      theme.ProductBlockManager.loadImages($(target));
      BUCKAROO.initCarousel($(target).find('.product-list'));
      setStatusProductOptions($('.product-picker'));
    };

    var setActiveBeltOptions = function () {
      refreshBeltGrid();
      var $belt = $('.product-picker .product-block');
      var $beltColors = $('.product-block-options--swatch .product-block-options__item');
      var $link = $('.product-list .product-block .popup-toggle');

      $link.on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        url = $this.attr('href');
        target = '#product-picker .product-preview__main';
        getAjaxData(url, target, 0, 1);

        $('.product-preview__close').on('click', function (e) {
          e.preventDefault();
          $(this).parent().hide();
          $(target).html('');
          scrollToTop();
        });
        //theme.showQuickPopup('TEST', $this);
        //window.open($(this).attr('href'), '_blank');
        return false;
      });

      $belt.on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.hasClass('disabled') == false) {
          var $link = $this.find('.image-cont .product-link');
          var $toggle = $this.find('.toggle');
          var url = $link.attr('href') + '?view=belt-options';
          var target = '.product-options';

          if ($toggle.hasClass('active') == false) {
            $belt.removeClass('active');
            $belt.find('.image-cont .product-link').removeClass('active');
            $belt.find('.toggle').removeClass('active');
            $this.addClass('active');
            $link.addClass('active');
            $toggle.addClass('active');
            getAjaxData(url, target, triggerLoadProductForm);
            scrollNextBYOBField($this);
          } else {
            $this.removeClass('active');
            $belt.find('.image-cont .product-link').removeClass('active');
            $belt.find('.toggle').removeClass('active');
            $(target).html('');
          }
        }
        setStatusProductOptions($('.product-picker'));
      });

      $beltColors.on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        var color = $this.data('swatch'); //option-selector--swatch

        $('.option-selector--swatch .opt-label[data-swatch=' + color + ']').trigger('click');
      });
    };

    var refreshAttachmentGrid = function () {
      var cookieBelt = JSON.parse(Cookies.get('byob_belt'));
      var target = '.attachment-picker .attachments';
      theme.ProductBlockManager.loadImages($(target));
      BUCKAROO.initCarousel($(target).find('.product-list'));
      var cookieAttachments = getAttachmentData();
      var attachments = cookieAttachments[currentBeltSelection];
      if (attachments != undefined && attachments.length > 0) {
        attachments.forEach(function (attachment, i) {
          $(target)
            .find('[data-product-id=' + attachment.product_id + '] .image-cont .product-link')
            .addClass('active');
          $(target)
            .find('[data-product-id=' + attachment.product_id + '] .toggle')
            .addClass('active');
        });
      }

      filterClickable(currentBeltSelection, cookieBelt.size);
      setStatusProductOptions($('.attachment-picker'));
    };

    var setActiveAttachmentOptions = function () {
      refreshAttachmentGrid();
      var $attachment = $('.attachment-picker .product-block');
      var cookieBelt = JSON.parse(Cookies.get('byob_belt'));
      var currentBeltSelectionAttachments = new Array();
      var $link = $('.product-list .product-block .product__link');

      $link.on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        url = $this.attr('href');
        target = '#attachment-picker .product-preview__main';
        getAjaxData(url, target, 0, 1);

        $('.product-preview__close').on('click', function (e) {
          e.preventDefault();
          $(this).parent().hide();
          $(target).html('');
          scrollToTop();
        });
        //theme.showQuickPopup('TEST', $this);
        //window.open($(this).attr('href'), '_blank');
        return false;
      });

      if (cookieAttachments == undefined || cookieAttachments == '') {
        cookieAttachments = {};
        currentBeltSelectionAttachments = new Array();
      } else {
        currentBeltSelectionAttachments = cookieAttachments[currentBeltSelection];
        if (currentBeltSelectionAttachments == undefined) {
          currentBeltSelectionAttachments = new Array();
        }
      }

      $attachment.on('click', function (e) {
        e.preventDefault();
        if (currentBeltSelectionAttachments == undefined) {
          currentBeltSelectionAttachments = new Array();
        }

        var $this = $(this);

        if ($this.hasClass('disabled') == false) {
          var pid = $(this).data('product-id');
          var varID = $(this).data('variant-id');
          var phandle = $(this).data('product-handle');
          var $link = $this.find('.image-cont .product-link');
          var $toggle = $this.find('.toggle');
          var width = $this.find('.frog_pouch_dimension').data('value');
          var pdata = {};
          if ($link.hasClass('active')) {
            // remove from cookie, increase allowed space
            $attachment.removeClass('active');
            currentBeltSelectionAttachments = productRemove(currentBeltSelectionAttachments, pid);
            $link.removeClass('active');
            $toggle.removeClass('active');
          } else {
            // check and decrease allowed space, add to cookie
            $attachment.removeClass('active');
            pdata = { product_handle: phandle, variation_id: varID, product_id: pid, dimension: width };
            currentBeltSelectionAttachments.push(pdata);
            $this.addClass('active');
            $link.addClass('active');
            $toggle.addClass('active');
          }
          Cookies.remove('byob_attachments');
          cookieAttachments = mergeAttachmentData(
            currentBeltSelectionAttachments,
            currentBeltSelection,
            cookieAttachments
          );
          Cookies.set('byob_attachments', JSON.stringify(cookieAttachments));
          byob_attachments = Cookies.get();
          updateSectionWidth(currentBeltSelection, cookieBelt.size);
          filterClickable(currentBeltSelection, cookieBelt.size);
        }
        setStatusProductOptions($('.attachment-picker'));
      });
    };
    var mergeAttachmentData = function (array, section, attachments, form = 'core') {
      let sections = new Array();
      let newObj = {};

      // prepare empty obj
      if (form == 'core') {
        $.each(attachmentWidthJson[currentBeltSize], function (key, value) {
          sections.push(key);
        });
      } else {
        sections = ['D', 'N', 'B'];
      }
      if (Object.keys(attachments).length == 0) {
        $.each(sections, function (key, value) {
          if (section == value) {
            newObj[value] = array;
          } else {
            newObj[value] = new Array();
          }
        });
      } else {
        $.each(attachments, function (key, value) {
          if (section == key) {
            newObj[key] = array;
          } else {
            newObj[key] = value;
          }
        });
      }
      return newObj;
    };

    var showSubTotal = function () {
      var $price = $('.view-selections__main .price-area .price');
      var $total = $('.view-selections__footer .money');
      var subtotal = 0;
      $price.each(function (i) {
        subtotal = parseFloat($(this).data('price-float')) + subtotal;
      });
      $total.text('$' + (subtotal / 100).toFixed(2) + ' ' + Shopify.currency.active);
    };
    var initViewSelections = function () {
      var cookieBelt = JSON.parse(Cookies.get('byob_belt'));
      var cookieAttachments = getAttachmentData();
      var className = 'view-selections__main--' + getBeltSize(cookieBelt.size);
      var confirmDelete = false;
      $('.view-selections__main')
        .removeClass('view-selections__main--regular')
        .removeClass('view-selections__main--large');
      $('.view-selections__main').addClass(className);
      $('.belt-selection-wrapper').html('');

      $('#view-selections .field .belt-size').text(cookieBelt.size + ' inch');

      var url = '/products/' + cookieBelt.handle + '?view=belt-selections&variant=' + cookieBelt.variation_id;
      var target = '#view-selections [data-section=X] .field__item';
      getAjaxData(url, target);

      updateSectionWidth('L', cookieBelt.size);
      updateSectionWidth('R', cookieBelt.size);
      updateSectionWidth('M', cookieBelt.size);
      updateSectionWidth('MR', cookieBelt.size);
      updateSectionWidth('ML', cookieBelt.size);

      var index = 1;
      $.each(cookieAttachments, function (section, attachments) {
        var delay = setTimeout(function () {
          doLoadSelectionItems(section, attachments);
        }, 800 * index);
        index = index + 1;
        // console.log('index:'+index);
      });

      delay = setTimeout(function () {
        showSubTotal();
      }, 800 * index);

      $('#pagefooter').hide();
    };

    var doLoadSelectionItems = function (section, attachments) {
      $.each(attachments, function (i, value) {
        url = '/products/' + value.product_handle + '?view=belt-selections';
        target = '#view-selections [data-section=' + section + '] .belt-selection-wrapper';
        var wrapped = '';
        try {
          $.ajax({
            url: url,
            type: 'GET',
            success: function (data) {
              wrapped = '<div class="belt-selection field__item">' + data + '</div>';
              $(target).append(wrapped);
              //console.log(target);
              $('.quantity-delete-row a[data-product-id=' + value.product_id + ']').on('click', function (e) {
                e.preventDefault();
                var pid = $(this).data('product-id');
                if (confirm('Are you sure want to remove this attachment?')) {
                  var sectionAttachments = {};
                  cookieAttachments = getAttachmentData();
                  sectionAttachments = cookieAttachments[section];
                  var newA = productRemove(sectionAttachments, pid);
                  Cookies.remove('byob_attachments');
                  cookieAttachments = mergeAttachmentData(newA, section, cookieAttachments);
                  Cookies.set('byob_attachments', JSON.stringify(cookieAttachments));
                  $(this).parent().parent().parent().parent().parent().fadeOut('fast');
                }
              });
            },
          });
        } catch (error) {
          console.error(error);
        }
      });
    };

    var getAjaxSelectionData = function (url, section, variant, calcTotal = 0) {
      var wrapped = '';
      var target = '#view-recommendations [data-section=' + section + '] .belt-selection-wrapper';
      $.ajax({
        url: url,
        type: 'GET',
      }).done(function (data) {
        wrapped = '<div class="belt-selection field__item">' + data + '</div>';
        $(target).append(wrapped);
        $('.quantity-delete-row a[data-variant=' + variant + ']').on('click', function (e) {
          e.preventDefault();
          var pid = $(this).data('variant');
          if (confirm('Are you sure want to remove this attachment?')) {
            var sectionAttachments = {};
            cookieAttachments = getAttachmentData();
            sectionAttachments = cookieAttachments[section];
            var newA = productRemove(sectionAttachments, pid, 'variation_id');
            Cookies.remove('byob_attachments');
            cookieAttachments = mergeAttachmentData(newA, section, cookieAttachments, 'guided');
            Cookies.set('byob_attachments', JSON.stringify(cookieAttachments));
            $(this)
              .parent()
              .parent()
              .parent()
              .parent()
              .parent()
              .fadeOut('fast', function (e) {
                loadViewRecommendations();
              });
          }
        });

        if (calcTotal) {
          setTimeout(showSubTotal, 1000);
        }
      });
    };

    var loadViewRecommendations = function () {
      var url = '';
      var beltData = JSON.parse(Cookies.get('byob_belt'));
      var cookieAttachments = JSON.parse(Cookies.get('byob_attachments'));
      var section = 'X';

      $('.belt-selection-wrapper').html('');
      url = '/products/' + beltData.handle + '?view=belt-selections&variant=' + beltData.variation_id;
      getAjaxSelectionData(url, section, beltData.variation_id, 0);

      $.each(cookieAttachments, function (section, attachments) {
        $.each(attachments, function (i, value) {
          // console.log(value.product_handle != "");
          if (Object.keys(value).length > 0 && value.product_handle != '') {
            url = '/products/' + value.product_handle + '?view=belt-selections';
            getAjaxSelectionData(url, section, value.variation_id, 1);
          }
        });
      });

      $('#pagefooter').hide();
    };

    var initViewRecommendations = function () {
      const version = $('#product-questionnaire').data('version');
      const $form = $('#product-questionnaire .product-form');
      var beltHandle = $form.find('[name=product-question__options--support-selector]:checked').val();
      if (version == 'v1') {
        beltHandle = $form.find('[name=belt-handle] option:selected').data('handle');
      }
      var $beltSize = $form.find('[name=product-question__options--size-selector]:checked');
      var $beltColor = $form.find('[name=product-question__options--color-selector]:checked');
      var $belt = $form.find('[name=' + beltHandle + '] option:selected');
      // var $dominant  = $form.find("[name=product-question__options--dominant-selector]:checked");
      var $dominantTool1 = $form.find('.product-question__slider--tool-1 .product-question__slider__item.active');
      var $dominantTool2 = $form.find('.product-question__slider--tool-2 .product-question__slider__item.active');
      var $nonDominant = $form.find('[name=product-question__options--non-dominant-selector]:checked');
      var $backHolder = $form.find('[name=product-question__options--back-holder-selector]:checked');
      var pdata = {};
      var section = '';
      $('#view-recommendations .field .belt-size').text($beltSize.val());

      Cookies.remove('byob_attachments');
      var cookieAttachments = {};

      $('.belt-selection-wrapper').html('');
      if ($belt != undefined) {
        var beltData = JSON.stringify({
          variation_id: $belt.data('variant'),
          size: $beltSize.val(),
          color: $beltColor.val(),
          handle: beltHandle,
        });
        Cookies.remove('byob_belt');
        Cookies.set('byob_belt', beltData);
      }

      var temp = new Array();
      section = 'D';
      if ($dominantTool1 != undefined) {
        pdata = { product_handle: $dominantTool1.data('handle'), variation_id: $dominantTool1.data('variant') };
        temp.push(pdata);
      }
      if ($dominantTool2 != undefined) {
        pdata = { product_handle: $dominantTool2.data('handle'), variation_id: $dominantTool2.data('variant') };
        temp.push(pdata);
      }
      cookieAttachments = mergeAttachmentData(temp, section, cookieAttachments, 'guided');

      if ($nonDominant != undefined) {
        var temp = new Array();
        pdata = { product_handle: $nonDominant.val(), variation_id: $nonDominant.data('variant') };
        temp.push(pdata);
        section = 'N';
        cookieAttachments = mergeAttachmentData(temp, section, cookieAttachments, 'guided');
      }

      if ($backHolder != undefined) {
        var temp = new Array();
        pdata = { product_handle: $backHolder.val(), variation_id: $backHolder.data('variant') };
        temp.push(pdata);
        section = 'B';
        cookieAttachments = mergeAttachmentData(temp, section, cookieAttachments, 'guided');
      }

      Cookies.set('byob_attachments', JSON.stringify(cookieAttachments));
      //console.log(cookieAttachments);
      loadViewRecommendations();
    };

    //initViewSelections();
    var setStatusProductOptions = function ($element) {
      var $tool = $element.find('.product-block .product-link');
      var hasActive = false;
      $tool.each(function (i) {
        var $this = $(this);
        //console.log($this.hasClass("active"));
        if ($this.hasClass('active')) {
          hasActive = true;
        }
      });
      if (hasActive) {
        $element.find('.product-block').removeClass('ready');
      } else {
        $element.find('.product-block').addClass('ready');
      }
    };

    var initStep1 = function () {
      var $defaultMenuLink = $('.template-suffix-byob-belt-picker .product-picker .collections');
      resetBeltNavigation();
      if ($defaultMenuLink.length > 0) {
        var url = $defaultMenuLink.data('default') + '?view=data';
        var target = '.product-picker .products';
        getAjaxData(url, target, setActiveBeltOptions);
        scrollToTop();
      }
    };

    var initBYOBCore = function () {
      if ($('.section-buckaroo-byob-belt-picker').length > 0) {
        var attachments = getAttachmentData();
        if ((Object.keys(attachments).length === 0 && attachments.constructor === Object) || 'D' in attachments) {
          resetBYOBCookies();
          initStep1();
        } else {
          initViewSelections();
          $('#product-picker').css('display', 'none');
          $('#view-selections').css('display', 'block');
        }
      }
    };

    var initStep3 = function () {
      var $defaultMenuLink = $('.attachment-picker .collections');
      if ($defaultMenuLink != undefined) {
        showAttachmentFirstLevel();
        /*var url = $defaultMenuLink.data("default") + '?view=data';
        var target = ".attachment-picker .attachments";
        getAjaxData(url, target, setActiveAttachmentOptions);*/
        scrollToTop();
      }
    };
    //initStep3();

    var $collMenuLink = $("[data-method='ajax']");
    $collMenuLink.on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      if ($this != undefined) {
        url = $this.attr('href') + '?view=data';
        target = $this.data('target');
        $collMenuLink.removeClass('active');
        $this.addClass('active');
        if (target == '.attachments') {
          getAjaxData(url, target, setActiveAttachmentOptions);
        } else {
          getAjaxData(url, target, setActiveBeltOptions); //, theme.loadCarousels
        }
      }
    });

    var hasBeltPicked = function () {
      var cookieBelt = Cookies.get('byob_belt');
      if (cookieBelt == undefined) {
        alert('Please pick a belt first.');
        scrollToTop();
        return false;
      } else {
        return true;
      }
    };

    $('.show-href').on('click', function (e) {
      e.preventDefault();
      let $this = $(this);
      const showThisId = $this.attr('href');
      var continueFade = true;
      var $fadeElement = $this.parent().parent().parent();
      if ($this.hasClass('btn--tertiary')) {
        $fadeElement = $this.parent().parent();
      }
      if ($this.hasClass('close')) {
        $fadeElement = $('.view-selections');
        $('#pagefooter').show();
      }
      if ($this.hasClass('show-href--level3')) {
        $fadeElement = $this.parent().parent().parent().parent().parent();
      }

      if (showThisId == '#start-selections') {
        continueFade = hasBeltPicked();
        if (continueFade) {
          showBaseBeltSize();
        }
      }

      if (showThisId == '#attachment-picker') {
        initStep3();
        prepareBeltSection($this.data('attachment-section'));
      }

      if (showThisId == '#view-selections') {
        initViewSelections();
      }
      if (showThisId == '#view-recommendations') {
        initViewRecommendations();
      }
      if (continueFade) {
        $fadeElement.fadeOut('fast', function () {
          $(showThisId).fadeIn();
        });
        scrollToTop();
      }
    });

    var setActiveToolsOptions = function () {
      var $tool = $('.product-question--dominant .product-question__slider__item');
      var $noTool2 = $('#product-question__options--no-tool-2-selector-opt-0');
      setStatusToolsOptions($('.product-question__slider--tool-1'));
      setStatusToolsOptions($('.product-question__slider--tool-2'));
      $noTool2.on('change', function (e) {
        if ($(this).is(':checked')) {
          $('.product-question__slider--tool-2').addClass('disabled');
          $('.product-question__slider--tool-2 .product-question__slider__item')
            .removeClass('active')
            .removeClass('ready');
        } else {
          $('.product-question__slider--tool-2').removeClass('disabled');
          $('.product-question__slider--tool-2 .product-question__slider__item').addClass('ready');
        }
      });
      $tool.on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        scrollNextGuideMeField($this);
        if ($this.hasClass('active')) {
          $this.parent().parent().find('.product-question__slider__item').removeClass('active');
        } else {
          $this.parent().parent().find('.product-question__slider__item').removeClass('active');
          $this.addClass('active');
        }
        setStatusToolsOptions($('.product-question__slider--tool-1'));
        setStatusToolsOptions($('.product-question__slider--tool-2'));
      });
    };

    var setStatusToolsOptions = function ($element) {
      var $tool = $element.find('.product-question__slider__item');
      var hasActive = false;
      $tool.each(function (i) {
        var $this = $(this);
        //console.log($this.hasClass("active"));
        if ($this.hasClass('active')) {
          hasActive = true;
        }
      });
      if (hasActive) {
        $element.find('.product-question__slider__item').removeClass('ready');
      } else {
        $element.find('.product-question__slider__item').addClass('ready');
      }
    };

    var setGuidedBeltVariation = function (version) {
      var $this = $('.product-question--support .option-selector__btns .js-option:checked');
      if ($this == undefined) {
        return false;
      }
      var size = $('.product-question--size .option-selector__btns .js-option:checked').val();
      var color = $('.product-question--color .option-selector__btns .js-option:checked').val();
      if (version == 'v1') {
        var backSupport = $this.next().find('span').text();
        if (color == undefined || backSupport == undefined) {
          return false;
        }
        var productHandle = $('select[name=belt-handle]')
          .val(backSupport + '|' + color)
          .change()
          .find('option:selected')
          .data('handle');
        //console.log(productHandle);
        $('select[name=' + productHandle + ']')
          .val(size)
          .change();
      } else {
        var options = color + '|' + size;
        var prodHandle = $this.val();
        $('select[name=' + prodHandle + ']')
          .val(options)
          .change();
      }
    };
    var initBYOBQuestionaire = function () {
      var version = $('#product-questionnaire').data('version');
      // console.log(version);
      $('.product-question--dominant .option-selector__btns .js-option').on('click', function () {
        $('.product-question--dominant .product-question__extension').fadeIn();
      });
      $('.product-question--support .option-selector__btns .js-option').on('click', function () {
        setGuidedBeltVariation(version);
      });
      $('.product-question--size .option-selector__btns .js-option').on('click', function () {
        setGuidedBeltVariation(version);
      });
      $('.product-question--color .option-selector__btns .js-option').on('click', function () {
        setGuidedBeltVariation(version);
      });
      $('.product-question__options .opt-btn').change(function () {
        scrollNextGuideMeField($(this));
      });

      setActiveToolsOptions();
    };

    var initBYOBGuideMe = function () {
      if ($('.section-buckaroo-byob-guide-me').length > 0) {
        var attachments = getAttachmentData();
        if (
          (Object.keys(attachments).length === 0 && attachments.constructor === Object) ||
          'L' in attachments ||
          'R' in attachments
        ) {
          resetBYOBCookies();
          initBYOBQuestionaire();
        } else {
          initBYOBQuestionaire();
          loadViewRecommendations();
          $('#product-questionnaire').css('display', 'none');
          $('#view-recommendations').css('display', 'block');
        }
      }
    };

    initBYOBGuideMe();

    var filterClickable = function (section, size) {
      var remaining = getAttachmentWidthLeft(size, section);
      $('.attachment-picker .product-block').each(function (i) {
        var $this = $(this);
        var $link = $this.find('.product-link');
        var dimension = $this.find('.frog_pouch_dimension').data('value');
        //console.log($this.data("product-handle") + ":" +  dimension);
        if (dimension == undefined) {
          $this.addClass('disabled');
        } else {
          if (remaining < parseInt(dimension) && $link.hasClass('active') == false) {
            $this.addClass('disabled');
          } else {
            $this.removeClass('disabled');
          }
        }
      });
      /*$(".disabled a.product-link").on("click", function(e){
        e.preventDefault();
        return false;
      });*/
    };

    var addBYOBToBag = function () {
      var items = new Array();
      var temp = {};
      var products = new Array();
      var productQty = new Array();
      var cookieBelt = JSON.parse(Cookies.get('byob_belt'));
      var cookieAttachments = getAttachmentData();
      // JSON.stringify({ variation_id: $(this).val(), size: beltSize, product_id: productID, color: beltColor, handle: productHandle });
      temp = { id: parseInt(cookieBelt.variation_id), quantity: 1 };
      items.push(temp);
      $.each(cookieAttachments, function (section, rows) {
        $.each(rows, function (i, row) {
          if (products.includes(row.variation_id)) {
            productQty[row.variation_id] = 1 + productQty[row.variation_id];
          } else {
            products.push(row.variation_id);
            productQty[row.variation_id] = 1;
          }
        });
      });
      $.each(products, function (key, variation_id) {
        if (variation_id) {
          temp = { id: variation_id, quantity: productQty[variation_id] };
          items.push(temp);
        }
      });
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: { items },
      })
        .done(function (data) {
          location.href = '/cart';
          resetBYOBCookies();
        })
        .fail(function (data) {})
        .always(function (data) {});
    };
    var removeMargin = function (e) {
      if ($(window).width() < 768) {
        if ($(e.currentTarget).hasClass('product-list')) {
          $(e.currentTarget).css('margin', '0');
        }
      }
    };

    var triggerDefaultSubLevelMenu = function () {
      const $categoryTemplate = $('.template-collection');
      const $categoryActiveSubMenu = $categoryTemplate.find(
        '.section-collection-tab-menu .tab-content .tab-pane.active'
      );
      const $categoryActiveMenu = $categoryTemplate.find(
        '.section-collection-tab-menu .nav-tabs .nav-item .nav-link.active'
      );
      if ($categoryTemplate.length > 0) {
        if ($categoryActiveSubMenu.length == 0) {
          if ($categoryActiveMenu.length > 0) {
            $($categoryActiveMenu.data('target')).css({ display: 'block' });
          } else {
            $categoryTemplate
              .find('.section-collection-tab-menu .nav-tabs .nav-item')
              .first()
              .find('.nav-link')
              .trigger('click');
          }
        }
      }
    };
    triggerDefaultSubLevelMenu();
    var selectDefaultThumbnail = function () {
      $('.gallery.has-thumbnails .thumbnails .thumbnail').first().addClass('selected');
    };

    var productRemove = function (data, id, by = 'product_id') {
      return data.filter(function (obj) {
        if (by == 'variation_id') {
          return obj.variation_id !== id;
        } else {
          return obj.product_id !== id;
        }
      });
    };
    var initBoughtTogetherCart = function () {
      var $formContainer = $('.product-list .buy-buttons-row');
      $formContainer.each(function () {
        theme.applyAjaxToProductForm($(this));
      });
      $('.continue-shopping').on('click', function (e) {
        e.preventDefault();
        history.back();
      });
    };
    var submitFooterForm = function () {
      $('#footer_newsletter_signup [type=submit]').attr('disabled', true);

      $('#footer-signup-email').on('blur', validateFooterForm);
      $('#footer-signup-email').on('keyup', validateFooterForm);
    };
    var validateFooterForm = function (e) {
      if (!isEmail(e.target)) {
        $('.form-input-error--signup-email').text('Please put your valid email address above.').css('display', 'block');
        $('#footer_newsletter_signup [type=submit]').attr('disabled', true);
      } else {
        $('#footer_newsletter_signup [type=submit]').removeAttr('disabled');
        $('.form-input-error[data-for=#footer-signup-email]').text('').css('display', 'none');
      }
    };
    var submitHelpForm = function () {
      $('#contact_form [type=submit]').attr('disabled', true);

      $('#contact_phone').on('keyup', validatePhoneField);
      $('#contact_email').on('keyup', validateEmailField);

      $('#contact_form [type=text]').on('focus', function (e) {
        // console.log('triggered');
        var validp = checkPhone(document.getElementById('contact_phone'));
        var valide = isEmail(document.getElementById('contact_email'));
        // console.log( validp + "|" + valide);
        if (validp && valide) {
          $('#contact_form [type=submit]').removeAttr('disabled');
        } else {
          $('#contact_form [type=submit]').attr('disabled', true);
        }
      });
    };
    var validateEmailField = function (e) {
      if (!isEmail(e.target)) {
        $(e.target)
          .parent()
          .find('.form-input-error')
          .text('Please put your valid email address above.')
          .css('display', 'block');
      } else {
        $(e.target).parent().find('.form-input-error').text('').css('display', 'none');
      }
    };
    var validatePhoneField = function (e) {
      if (!checkPhone(e.target)) {
        $(e.target)
          .parent()
          .find('.form-input-error')
          .text('Please put a valid phone number above.')
          .css('display', 'block');
      } else {
        $(e.target).parent().find('.form-input-error').text('').css('display', 'none');
      }
    };
    initBoughtTogetherCart();
    selectDefaultThumbnail();
    initHashScroll();
    initBYOBCore();
    BUCKAROO.initCarousel($('[data-carousel]'), BUCKAROO.initTabMenu());
    initResponsiveFunc();
    submitFooterForm();
    submitHelpForm();
    BUCKAROO.initFeaturedProductsCarousel();
    // BUCKAROO.sizeChartLoadHandler();
    // BUCKAROO.stickyProductForm();


    $('#byob-addtobag').on('click', addBYOBToBag);

    $('.trigger-toggle').on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $toggle = $this.parent().find('.toggle');
      if ($toggle.hasClass('hide')) {
        $this.addClass('active');
        $toggle.removeClass('hide');
      } else {
        $this.removeClass('active');
        $toggle.addClass('hide');
      }
    });

    //get help template
    $('.section-intro--get-help .form-btn').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('.get-help-section-contact').slideToggle();
    });

    //anchor link animated
    // please be specific on the selector, some a tag with hash doesn't need this, please check the initHashScroll among the functions here, it only needs scroll-to class
    $(document).on('click', '.overlay-text__arrow-down a[href^="#"]', function (e) {
      e.preventDefault();
      var id = $(this).attr('href');
      $('html,body').animate({ scrollTop: $(id).offset().top }, 500);
    });

    //tidio chat on click trigger
    $('.chat-tidio-btn').on('click', function (e) {
      e.preventDefault();
      window.tidioChatApi.show();
      window.tidioChatApi.open();
    });

    $('.toggle-tidio-chat').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('#tidio-chat').toggle();
    });
  });
})(theme.jQuery);

var applyPOSParam = function (element) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const view = urlParams.get('view');
  let newURL = '';
  if (view == 'pos') {
    var $anchors = document.querySelectorAll(element + ' a');
    $anchors.forEach(function (item, i, arr) {
      newURL = item.href;
      if (newURL.includes('#') == false) {
        newURL = updateURLParameter(newURL, 'view', 'pos');
        item.href = newURL;
      }
    });
    $('.logo__link').removeAttr('href');
    const $tabProductInfo = $('.product-detail-tab');
    if ($tabProductInfo.length > 0) {
      window.setTimeout(function () {
        $tabProductInfo.find('.nav-item:first-child .nav-link').trigger('click');
      }, 1000);
    }
  } else {
    document.getElementById('pagefooter').style.cssText = 'display:inherit';
    document.querySelector('.logo-area__left').style.cssText = 'display:inherit';
    document.querySelector('.logo-area__right').style.cssText = 'display:inherit';
  }
};
var isMobile = function () {
  const regexp = /android|iphone|kindle|ipad/i;
  return regexp.test(navigator.userAgent);
};
var updateURLParameter = function (url, key, value) {
  var newAdditionalURL = '';
  var tempArray = url.split('?');
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = '';
  if (additionalURL) {
    tempArray = additionalURL.split('&');
    for (var i = 0; i < tempArray.length; i++) {
      if (tempArray[i].split('=')[0] != key) {
        newAdditionalURL += temp + tempArray[i];
        temp = '&';
      }
    }
  }

  var rows_txt = temp + '' + key + '=' + value;
  return baseURL + '?' + newAdditionalURL + rows_txt;
};
var isEmail = function (elem, helperMsg = '') {
  var regexp = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if (regexp.test(elem.value)) {
    return true;
  } else {
    return false;
  }
};
var checkPhone = function (elem, msg = '') {
  var str = elem.value;
  var phone2 = /^(?=.*[0-9])[- +()0-9]+$/; // loose version
  if (str.match(phone2) && str.length > 7) {
    return true;
  } else {
    return false;
  }
};
applyPOSParam('body');
